import React, { useState, useEffect, useRef } from "react";
import "./MultiSelector.css";
import Icons from '../../Assets/Icons/index';
import { useTranslation } from "react-i18next";

const MultiSelector = ({ options, selectedOptions, setSelectedOptions, onSelect }) => {
      const { t } = useTranslation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleSelectChange = (option) => {
        if (!selectedOptions.some(selected => selected.value === option.value)) {
            setSelectedOptions([...selectedOptions, option]);
            if (onSelect) {
                onSelect(option.value); // Call the onSelect function with the selected ID
            }
        }
        setIsDropdownOpen(false);
    };

    const handleDelete = (optionToDelete) => {
        setSelectedOptions(selectedOptions.filter((option) => option.value !== optionToDelete.value));
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="multi-selector-container" ref={dropdownRef}>
            <div className="dropdown" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                {t("selOptions")}
                <span className="arrow"><img src={Icons.downArrow} alt="arrow" /></span>
            </div>
            {isDropdownOpen && (
                <div className="sel-dropdown-list">
                    {options.map((option) => (
                        <div key={option.value} className="sel-dropdown-item text-size" onClick={() => handleSelectChange(option)}>
                            {option.label}
                        </div>
                    ))}
                </div>
            )}

            <div className="selected-options">
                {selectedOptions.map((option) => (
                    <span key={option.value} className="chip">
                        {option.label}
                        <span className="close" onClick={() => handleDelete(option)}>×</span>
                    </span>
                ))}
            </div>
        </div>
    );
};

export default MultiSelector;